module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo1-f03b0451d09b589b65b1c427d0958d21.png";